import styled from 'styled-components';

import {
  breakpoints,
  colors,
  fontFamily,
  functions,
  zIndex,
} from '../../ui/variables';

export const ExamResumeChartStyle = styled.div`
  background-color: ${colors.mostlyWhite};
  border-radius: 20px;
  box-shadow: 0 3px 20px ${functions.rgba(colors.grayishBlue, 0.25)};
  padding: 16px 20px 22px;
  width: 100%;

  @media (min-width: ${breakpoints.hd.width}px) {
    box-shadow: none;
    height: 100%;
  }

  .exam-resume-chart-title {
    ${fontFamily.sourceSansPro.bold};
    color: ${colors.veryDarkGrayishBlue};
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 6px;
  }

  .exam-resume-chart-container {
    height: 150px;
    margin: 0 auto;
    position: relative;
    width: 150px;

    .chart-empty-wrapper,
    .chart-approved-wrapper,
    .chart-reviewed-wrapper,
    .chart-role-wrapper {
      left: 50%;
      position: absolute;
      width: 100%;

      svg {
        display: block;
        height: 100%;
        width: auto;
      }
    }

    .chart-empty-wrapper,
    .chart-approved-wrapper {
      bottom: 0;
      top: 0;
      transform: translateX(-50%);
    }

    .chart-empty-wrapper {
      svg {
        fill: ${colors.lightGrayishBlue};
      }
    }

    .chart-approved-wrapper {
      svg {
        fill: ${colors.limeGreen};
      }
    }

    .chart-reviewed-wrapper {
      ${zIndex.hills};
      bottom: 0;
      top: 0;
      transform: translateX(-50%) rotate(-90deg);

      svg {
        fill: ${colors.lightOrange};
      }
    }

    .chart-role-wrapper {
      ${zIndex.sky};
      height: 94px;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 150px;

      svg {
        fill: ${colors.mostlyWhite};
        margin: 0 auto;
      }
    }

    .chart-label {
      position: absolute;

      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      &:before {
        border-radius: 50%;
        height: 10px;
        width: 10px;
      }

      &:after {
        height: 2px;
        width: 40px;
      }

      &.chart-label-approved {
        bottom: 16px;
        left: 0;
        transform: translateX(-100%);
        padding-right: 32px;

        &:before,
        &:after {
          background-color: ${colors.limeGreen};
        }

        &:before {
          right: 16px;
        }

        &:after {
          right: -16px;
        }

        &.revert-position {
          bottom: initial;
          top: 0;
          transform: translateX(calc(-100% + 12px));
        }

        .label-value {
          color: ${colors.limeGreen};
        }

        .label-quantity {
          color: ${colors.limeGreen};
        }
      }

      &.chart-label-reviewed {
        top: 0;
        right: 0;
        transform: translateX(calc(100% - 12px));
        padding-left: 32px;

        &:before,
        &:after {
          background-color: ${colors.lightOrange};
        }

        &:before {
          left: 16px;
        }

        &:after {
          left: -16px;
        }

        &.revert-position {
          bottom: 16px;
          top: inherit;
          transform: translateX(100%);
        }

        .label-value {
          color: ${colors.lightOrange};
          text-align: right;
        }

        .label-quantity {
          color: ${colors.lightOrange};
          text-align: right;
        }
      }

      .label-text {
        ${fontFamily.sourceSansPro.regular};
        display: block;
        font-size: 12px;
        line-height: 15px;
        text-transform: uppercase;
      }

      .label-value {
        ${fontFamily.sourceSansPro.bold};
        display: block;
        font-size: 18px;
        line-height: 23px;
      }

      .label-quantity {
        ${fontFamily.sourceSansPro.regular};
        display: block;
        font-size: 12px;
        line-height: 15px;
        margin-top: 4px;
      }
    }
  }
`;
